import { render } from "./UrlElement.vue.js?vue&type=template&id=4e3b7a8c!=!../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./UrlElement.vue?vue&type=template&id=4e3b7a8c"
import script from "./UrlElement.vue.js?vue&type=script&lang=js!=!../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./UrlElement.vue?vue&type=script&lang=js"
export * from "./UrlElement.vue.js?vue&type=script&lang=js!=!../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./UrlElement.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/SharedWeb/scripts/dynamic-component-editor/standard-elements/url-element/UrlElement.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4e3b7a8c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4e3b7a8c', __exports__)) {
    api.reload('4e3b7a8c', __exports__)
  }
  
  module.hot.accept("./UrlElement.vue.js?vue&type=template&id=4e3b7a8c!=!../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./UrlElement.vue?vue&type=template&id=4e3b7a8c", () => {
    api.rerender('4e3b7a8c', render)
  })

}


export default __exports__